import { z } from "zod";
import { RECORD_TYPES } from "@miplatform/constants";

export const schema = z.object({
  name: z.string().min(1, "Name is required"),
  recordType: z.enum([
    RECORD_TYPES.RECORDABLE,
    RECORD_TYPES.INTERNAL_DELAY,
    RECORD_TYPES.PUNCH,
    RECORD_TYPES.WEATHER,
    RECORD_TYPES.SERVICE_ITEM,
    RECORD_TYPES.CAMERA_LINE,
  ]),
  canBeSelfResolved: z.boolean(),
  canBeNotStarted: z.boolean(),
});
